module.exports = __webpack_public_path__ + "img/completed-steps-animate.fe55a07a.svg";